// src/ui/media.ts: the phone breakpoint as a signal. The phone (below 768px) is its own layout, not a squeezed
// desktop (docs/DECISIONS.md, "The phone is its own layout"): most of it is CSS (src/styles/phone.css), and a
// screen reads `isPhone` only where the phone shows different things (Home's room rows and short activity lines).
// One matchMedia listener for the whole app; components that read `isPhone.value` re-render when it flips.
import { signal } from "@preact/signals";

/** Keep in step with the `max-width: 767px` blocks in phone.css and the screen styles. */
export const PHONE_QUERY = "(max-width: 767px)";

const mq = typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(PHONE_QUERY) : null;

export const isPhone = signal(mq?.matches ?? false);

mq?.addEventListener?.("change", () => {
  isPhone.value = mq.matches;
});
